import { useSyncExternalStore } from 'react';

let host: HTMLElement | null = null;
const listeners = new Set<() => void>();

/** Callback ref for the element toasts should render inside; null falls back to the viewport. */
export function setToastHost(element: HTMLElement | null): void {
  if (host === element) return;
  host = element;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useToastHost(): HTMLElement | null {
  return useSyncExternalStore(subscribe, () => host, () => null);
}
